(function () {
  'use strict';

  function initScrollReveal() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('hk-revealed');
            if (!entry.target.classList.contains('hk-stitch-path')) {
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: '-80px 0px', threshold: 0.01 }
    );
    document.querySelectorAll('.hk-reveal, .hk-reveal-scale, .hk-stitch-path').forEach((el) => observer.observe(el));
  }

  function initHeroAnimations() {
    document.querySelectorAll('[data-hk-hero-enter]').forEach((el) => {
      const delay = parseFloat(el.dataset.hkDelay || '0');
      const duration = parseFloat(el.dataset.hkDuration || '0.8');
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity ' + duration + 's cubic-bezier(0.22,1,0.36,1) ' + delay + 's, transform ' + duration + 's cubic-bezier(0.22,1,0.36,1) ' + delay + 's';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }));
    });
    const arrow = document.querySelector('[data-hk-bounce-arrow]');
    if (arrow) arrow.classList.add('hk-animate-bounce-y');
  }

  function initFrog() {
    const btn = document.querySelector('[data-hk-frog-btn]');
    const label = document.querySelector('[data-hk-frog-label]');
    const frogBody = document.querySelector('[data-hk-frog-body]');
    const mouthNormal = document.querySelector('[data-hk-mouth-normal]');
    const mouthOpen = document.querySelector('[data-hk-mouth-open]');
    const tongueEl = document.querySelector('[data-hk-tongue]');
    const frogSvg = document.querySelector('[data-hk-frog-svg]');
    if (!btn || !frogSvg) return;
    let fed = 0, tongueActive = false;

    function feed() {
      if (tongueActive) return;
      const from = Math.random() > 0.5 ? 'left' : 'right';
      const flyG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      flyG.classList.add('hk-fly');
      if (from === 'right') flyG.classList.add('from-right');
      flyG.innerHTML = '<g transform="translate(160 200)"><circle r="3.5" fill="hsl(92,35%,20%)"/><ellipse cx="-4" cy="-2" rx="5" ry="2.5" fill="hsl(92,35%,20%)" opacity=".35"/><ellipse cx="4" cy="-2" rx="5" ry="2.5" fill="hsl(92,35%,20%)" opacity=".35"/></g>';
      frogSvg.appendChild(flyG);
      setTimeout(() => {
        tongueActive = true;
        if (frogBody) frogBody.classList.add('hk-tongue-active');
        if (mouthNormal) mouthNormal.style.display = 'none';
        if (mouthOpen) mouthOpen.style.display = '';
        if (tongueEl) { tongueEl.style.display = ''; tongueEl.style.animation = 'none'; tongueEl.offsetHeight; tongueEl.style.animation = ''; }
      }, 700);
      setTimeout(() => {
        tongueActive = false;
        if (frogBody) frogBody.classList.remove('hk-tongue-active');
        if (mouthNormal) mouthNormal.style.display = '';
        if (mouthOpen) mouthOpen.style.display = 'none';
        if (tongueEl) tongueEl.style.display = 'none';
        flyG.remove();
        fed++;
        if (label) label.textContent = fed === 1 ? 'fed 1 fly ♡' : 'fed ' + fed + ' flies ♡';
        const heartG = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        heartG.classList.add('hk-heart');
        heartG.innerHTML = '<path d="M160 180 c -6 -12 -24-8 -24 6 0 10 16 20 24 26 8-6 24-16 24-26 0-14-18-18-24-6 Z" fill="hsl(9,50%,92%)"/>';
        frogSvg.appendChild(heartG);
        setTimeout(() => heartG.remove(), 1400);
      }, 1050);
    }

    btn.addEventListener('click', feed);
    if (mouthOpen) mouthOpen.style.display = 'none';
    if (tongueEl) tongueEl.style.display = 'none';
  }

  function initAmbientSound() {
    const btn = document.querySelector('[data-hk-sound-btn]');
    const labelEl = document.querySelector('[data-hk-sound-label]');
    const iconOn = document.querySelector('[data-hk-sound-icon-on]');
    const iconOff = document.querySelector('[data-hk-sound-icon-off]');
    if (!btn) return;
    let on = false, ctx = null, nodes = null;

    async function start() {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!ctx) ctx = new Ctx();
      if (ctx.state === 'suspended') await ctx.resume();
      const master = ctx.createGain();
      master.gain.value = 0;
      master.connect(ctx.destination);
      master.gain.linearRampToValueAtTime(0.08, ctx.currentTime + 1.6);
      const oscs = [], lfos = [];
      [130.81, 164.81, 196.0, 246.94].forEach((f, i) => {
        const o = ctx.createOscillator();
        o.type = i % 2 ? 'sine' : 'triangle';
        o.frequency.value = f;
        const g = ctx.createGain();
        g.gain.value = 0.18;
        const lfo = ctx.createOscillator();
        lfo.frequency.value = 0.06 + i * 0.03;
        const lfoGain = ctx.createGain();
        lfoGain.gain.value = 0.08;
        lfo.connect(lfoGain).connect(g.gain);
        o.connect(g).connect(master);
        o.start(); lfo.start();
        oscs.push(o); lfos.push(lfo);
      });
      const bufferSize = 2 * ctx.sampleRate;
      const noiseBuf = ctx.createBuffer(1, bufferSize, ctx.sampleRate);
      const data = noiseBuf.getChannelData(0);
      for (let i = 0; i < bufferSize; i++) data[i] = (Math.random() * 2 - 1) * 0.4;
      const noise = ctx.createBufferSource();
      noise.buffer = noiseBuf;
      noise.loop = true;
      const filter = ctx.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.value = 480;
      const noiseGain = ctx.createGain();
      noiseGain.gain.value = 0.05;
      noise.connect(filter);
      filter.connect(noiseGain);
      noiseGain.connect(master);
      noise.start();
      nodes = {
        stop() {
          const t = ctx.currentTime;
          master.gain.cancelScheduledValues(t);
          master.gain.setValueAtTime(master.gain.value, t);
          master.gain.linearRampToValueAtTime(0.0001, t + 0.6);
          setTimeout(() => { oscs.forEach(o => o.stop()); lfos.forEach(l => l.stop()); noise.stop(); }, 700);
        }
      };
    }

    function setUI(isOn) {
      btn.setAttribute('aria-pressed', String(isOn));
      if (labelEl) labelEl.textContent = isOn ? 'cozy sound on' : 'play cozy sound';
      if (iconOn) iconOn.style.display = isOn ? '' : 'none';
      if (iconOff) iconOff.style.display = isOn ? 'none' : '';
    }

    btn.addEventListener('click', async () => {
      if (on) { nodes && nodes.stop(); nodes = null; on = false; }
      else { await start(); on = true; }
      setUI(on);
    });
    setUI(false);
  }

  function initPhotoFrames() {
    document.querySelectorAll('[data-hk-tilt]').forEach((el) => {
      const tilt = parseFloat(el.dataset.hkTilt || '0');
      el.style.transform = 'rotate(' + tilt + 'deg)';
      el.style.opacity = '0';
      el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
      const obs = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { e.target.style.opacity = '1'; obs.unobserve(e.target); } });
      }, { rootMargin: '-60px', threshold: 0.1 });
      obs.observe(el);
    });
  }

  function init() {
    initScrollReveal();
    initHeroAnimations();
    initFrog();
    initAmbientSound();
    initPhotoFrames();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
